import { render, staticRenderFns } from "./CPSH.vue?vue&type=template&id=180bbf1a&"
import script from "./CPSH.vue?vue&type=script&lang=js&"
export * from "./CPSH.vue?vue&type=script&lang=js&"
import style0 from "./CPSH.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('180bbf1a')) {
      api.createRecord('180bbf1a', component.options)
    } else {
      api.reload('180bbf1a', component.options)
    }
    module.hot.accept("./CPSH.vue?vue&type=template&id=180bbf1a&", function () {
      api.rerender('180bbf1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/61980520-8/CPSH.vue"
export default component.exports